import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import App from "./App";
import "core-js";
import "rsuite/DatePicker/styles/index.css";
import "./App.css";
import "./css/index.css";
import "./css/rtl.css";
import "./i18n";
import { BrowserRouter } from "react-router-dom";
import Keycloak from "keycloak-js";
import { KeycloakProvider } from "keycloak-react-web";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

let keycloakEnabled = process.env.REACT_APP_KEYCLOAK_ENABLED === "true";

if (keycloakEnabled) {
  const keycloakSetting = {
    url: process.env.REACT_APP_KEYCLOAK_BASE,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  };
  const authInstance = new Keycloak(keycloakSetting);
  window.keycloak = authInstance;

  window.keycloak.onAuthLogout = () => {
    window.keycloak.logout();
    console.log("onAuthLogout!");
  };

  // const  keycloakBase = process.env.REACT_APP_KEYCLOAK_BASE;

  // window.addEventListener("message", (event) => {
  //   let message = event.data;
  //
  //   if (event.origin === keycloakBase) {
  //     // console.log("Keycloak Event:", message, event);
  //
  //     if (message === "error") {
  //       window.keycloak.logout();
  //     }else if (message === "changed") {
  //       window.keycloak.logout();
  //     }
  //   }
  // });



  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <KeycloakProvider
          client={authInstance}
          initOptions={{
            onLoad: "check-sso",
            silentCheckSsoRedirectUri:
              window.location.origin + "/silent-check-sso.html",
            responseMode: "query",
            // checkLoginIframe: true,
            // checkLoginIframeInterval: 10,
          }}
        >
          <BrowserRouter basename="/">
            <App />
          </BrowserRouter>
        </KeycloakProvider>
      </PersistGate>
    </Provider>,
  );
} else {
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>,
  );
}
